export default __webpack_public_path__ + "static/media/almendra.0fb2fc55.pdf";